import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import Select from "react-select";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";

const ApproveTraining = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(5);
  const [approveTrainingData, setApproveTrainingData] = useState([]);
  const [payRollMonthOption, setPayRollMonthOption] = useState([]);
  const [currentItemID, setCurrentItemID] = useState(null);

  const [apiStatus, setApiStatus] = useState(undefined)
  const [formData, setFormData] = useState({
    TrainingDays: "",
    IsIncludeHoliday: 0,
    CalTrainingAmount: "",
    ApprovedTrainingAmount: "",
    PayrollMonthID: "",
    ActionRemark: "",
  });


  useEffect(() => {
    dispatch(updateNavbarHeading("Approve Training"));
    fetchApproveTrainingData();
  }, []);
  ;

  const fetchApproveTrainingData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/approve-training`
      );
      if (response.status === 200) {
        setApiStatus(response?.status)
        const trainingData = response?.data?.data;
        setApproveTrainingData(trainingData);
      } else {
        console.error(
          "Failed to fetch My Project. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Project:", error);
    }
  };

  const filteredData = Array.isArray(approveTrainingData)
    ? approveTrainingData.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];

  // Get current items for pagination
  const indexOfLastItem = currentPage * selectedRecordsPerPage;
  const indexOfFirstItem = indexOfLastItem - selectedRecordsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const recordsPerPageOption = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    setSelectedRecordsPerPage(newRecordsPerPage);
    setItemsPerPage(newRecordsPerPage);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleChange = (e) => {
    const { id, type, value, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSelectChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      PayrollMonthID: selectedOption?.value || "", // ✅ correct key!
    }));
  };

  const handleApprove = async (item) => {
    setShowModal(true);
    setCurrentItemID(item.ID);
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/approve-training/${item.ID}`
      );

      // Payroll Month List
      const monthData = response?.data?.data?.month;
      const monthOpt =
        monthData?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        })) || [];

      setPayRollMonthOption(monthOpt);
      const responseData = response?.data?.data?.trainningData;
      setFormData({
        TrainingDays: responseData?.TrainingDays || "",
        CalTrainingAmount: responseData?.CalTrainingAmount || "",
        ApprovedTrainingAmount: responseData?.CalTrainingAmount || "",
        PayrollMonthID: monthOpt[0].value || null,
      });
    } catch (error) {
      console.error("API error:", error);
    }
  };
  const handleReject = (item) => {
    setShowRejectModal(true);
    setCurrentItemID(item.ID);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      Status: 826, //for Approval
      ActionRemark: formData.ActionRemark,
      TrainingDays: parseInt(formData.TrainingDays, 10),
      IsIncludeHoliday: formData.IsIncludeHoliday ? 1 : 0,
      CalTrainingAmount: parseFloat(formData.CalTrainingAmount),
      ApprovedTrainingAmount: parseFloat(formData.ApprovedTrainingAmount),
      PayrollMonthID: parseInt(formData.PayrollMonthID, 10),
    };

    try {
      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/approve-training/${currentItemID}`,
        payload,
        "put"
      );
      setShowModal(false);
      toast.success("Training Approve successfully");
      window.location.reload();
    } catch (err) {
      console.error("Submission error", err);
    }
  };

  const handleRejectTraining = async (e) => {
    e.preventDefault();

    const payload = {
      Status: 827, // for Reject
      ActionRemark: formData.ActionRemark || "",  // still allow comment
      TrainingDays: "",
      IsIncludeHoliday: "",
      CalTrainingAmount: "",
      ApprovedTrainingAmount: "",
      PayrollMonthID: "",
    };

    try {
      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/approve-training/${currentItemID}`,
        payload,
        "put"
      );
      setShowRejectModal(false);
      toast.success("Training Rejected successfully");
      window.location.reload();
    } catch (err) {
      console.error("Submission error", err);
    }
  };


  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className=" rounded bg-white" id="skill-table-area">
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <div className="me-1">
                <SearchBar
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered table-hover mb-0">
              <thead id="thcolor">
                <tr>
                  <th>Employee</th>
                  <th>Client</th>
                  <th class="project-column">Project</th>
                  <th class="course-column">Course</th>
                  <th colspan="2" class="text-center">
                    Date
                  </th>
                  <th colspan="2" class="text-center">
                    Attendee
                  </th>
                  <th>Score</th>
                  <th>Std.Rate</th>
                  <th>Closed Date</th>
                  <th>#Days</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                <tr>
                  <th colspan="4"></th>
                  <th class="text-center">From</th>
                  <th class="text-center">To</th>
                  <th class="text-center">Count</th>
                  <th class="text-center">List</th>
                  <th colspan="7"></th>
                </tr>
              </thead>
           {apiStatus === 200 ? (
  currentItems.length > 0 ? (
    <tbody>
      {currentItems.map((item, index) => (
        <tr key={item.ID || index}>
          <td>{item.Employee || "-"}</td>
          <td>{item.Client || "-"}</td>
          <td>{item.Project || "-"}</td>
          <td dangerouslySetInnerHTML={{ __html: item.Course || "-" }}></td>
          <td className="text-center">
            {item.FromDate
              ? moment(item.FromDate).format("DD-MMM-YYYY")
              : "-"}
          </td>
          <td className="text-center">
            {item.ToDate
              ? moment(item.ToDate).format("DD-MMM-YYYY")
              : "-"}
          </td>
          <td className="text-center">{item.AttendeeCount || "-"}</td>
          <td className="text-center">-</td>
          <td>{item.FeedbackScore || "-"}</td>
          <td>{item.StdRate || "-"}</td>
          <td>
            {item.TrainingClosedDate
              ? moment(item.TrainingClosedDate).format("DD-MMM-YYYY")
              : "-"}
          </td>
          <td>{item.TrainingDays || "-"}</td>
          <td>{item.CalTrainingAmount || "-"}</td>
          <td>{item.ApplicationStatus || "-"}</td>
          <td>
            <div className={`action-icons ${item.canedit === 0 ? 'disabled' : ''}`}>
              <span
                onClick={(e) => {
                  e.preventDefault();
                  if (item.canedit === 1) handleApprove(item);
                }}
                style={{ 
                  cursor: item.canedit === 1 ? 'pointer' : 'not-allowed', 
                  opacity: item.canedit === 1 ? 1 : 0.5 
                }}
                title={item.canedit === 1 ? "Approve" : "Action not allowed"}
              >
                <i className="fa fa-check"></i>
              </span>
              <span
                onClick={(e) => {
                  e.preventDefault();
                  if (item.canedit === 1) handleReject(item);
                }}
                style={{ 
                  cursor: item.canedit === 1 ? 'pointer' : 'not-allowed', 
                  opacity: item.canedit === 1 ? 1 : 0.5 
                }}
                title={item.canedit === 1 ? "Reject" : "Action not allowed"}
              >
                <i className="fa fa-close"></i>
              </span>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  ) : (
    <tbody>
      <tr>
        <td colSpan={15} className="text-center py-4">
          No Data Found
        </td>
      </tr>
    </tbody>
  )
) : apiStatus === undefined ? (
  <tbody>
    <tr>
      <td colSpan={15} className="text-center py-4">
        <div className="d-flex flex-column align-items-center">
          <FaSpinner className="spinner" />
          <span className="mt-2">Loading</span>
        </div>
      </td>
    </tr>
  </tbody>
) : null}
            </table>

            <div className="d-flex justify-content-between mt-3">
              <div>
                <span className="d-flex">
                  Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
                  {Math.min(
                    currentPage * selectedRecordsPerPage,
                    filteredData.length
                  )}{" "}
                  of {filteredData.length} <span className="ms-1">results</span>
                  <select
                    value={selectedRecordsPerPage}
                    onChange={handleRecordsPerPage}
                    className="mx-2 form-select-sm"
                  >
                    {recordsPerPageOption.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </span>
              </div>
              <div>
                <Pagination
                  itemsPerPage={selectedRecordsPerPage}
                  totalItems={filteredData.length}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    {showModal && (
  <div
    className="modal"
    tabIndex="-1"
    role="dialog"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1050
    }}
  >
    <div 
      className="modal-dialog modal-md" 
      role="document"
      style={{
        width: "500px",
        margin: 0
      }}
    >
      <div className="modal-content">
        <div className="modal-header" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px 8px 0 0'
        }}>
          <p style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#27568B',
            margin: '0'
          }}>Approve Training</p>
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '18px',
              color: '#000',
              padding: '4px',
              borderRadius: '4px',
              transition: 'all 0.2s',
              lineHeight: '1'
            }}
            onClick={() => setShowModal(false)}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        <div className="modal-body p-3">
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="TrainingDays" className="form-label">
                  #Days
                </label>
                <input
                  type="number"
                  className="form-control text-end"
                  id="TrainingDays"
                  value={formData.TrainingDays}
                  onChange={handleChange}
                  disabled
                />
              </div>
              <div className="col-md-6">
                <div className="form-check mt-4 pt-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="IsIncludeHoliday"
                    checked={formData.IsIncludeHoliday}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="IsIncludeHoliday"
                  >
                    Include Holiday
                  </label>
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="CalTrainingAmount" className="form-label">
                  Amount
                </label>
                <input
                  type="text"
                  className="form-control text-end"
                  id="CalTrainingAmount"
                  value={formData.CalTrainingAmount}
                  onChange={handleChange}
                  disabled
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="ApprovedTrainingAmount" className="form-label">
                  Approved Amt
                </label>
                <input
                  type="text"
                  className="form-control text-end"
                  id="ApprovedTrainingAmount"
                  value={formData.ApprovedTrainingAmount}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-6">
                <label htmlFor="PayrollMonthID" className="form-label">
                  Payroll Month
                </label>
                <Select
                  options={payRollMonthOption}
                  value={
                    payRollMonthOption.find(
                      (opt) => opt.value === formData.PayrollMonthID
                    ) || null
                  }
                  onChange={handleSelectChange}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="ActionRemark" className="form-label">
                  Remarks
                </label>
                <textarea
                  className="form-control"
                  id="ActionRemark"
                  value={formData.ActionRemark}
                  onChange={handleChange}
                  rows="3"
                />
              </div>
            </div>

            <div className="text-end mt-1">
              <button 
                type="button" 
                className="cancel-btn me-2" 
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button type="submit" className="custom-btn">
                Approve
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
)}

      {/* Reject Model */}
{showRejectModal && (
  <div
    className="modal"
    tabIndex="-1"
    role="dialog"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1050
    }}
  >
    <div 
      className="modal-dialog modal-sm" 
      role="document"
      style={{
        width: "300px",
        margin: 0
      }}
    >
      <div className="modal-content">
        <div className="modal-header" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #f0f0f0',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px 8px 0 0'
        }}>
          <p style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#27568B',
            margin: '0'
          }}>Reject Training</p>
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '18px',
              color: '#000',
              padding: '4px',
              borderRadius: '4px',
              transition: 'all 0.2s',
              lineHeight: '1'
            }}
            onClick={() => setShowRejectModal(false)}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        <div className="modal-body p-2">
          <form onSubmit={handleRejectTraining}>
            <div className="row">
              <div className="col-md-12">
                <textarea
                  className="form-control"
                  id="ActionRemark"
                  value={formData.ActionRemark}
                  onChange={handleChange}
                  placeholder="Remark"
                />
              </div>
            </div>
            <div className="text-end mt-2">
              <button 
                type="button" 
                className="cancel-btn-sm me-2" 
                onClick={() => setShowRejectModal(false)}
              >
                Cancel
              </button>
              <button type="submit" className="custom-btn-sm">
                Reject
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
)}
    </>
  );
};

export default ApproveTraining;
